import { FC } from 'react';

import { Drawer as UIDrawer } from './drawer.styles';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const Drawer: FC<Props> = ({ open, children, onClose }) => (
  <UIDrawer anchor="right" open={open} onClose={onClose}>
    {children}
  </UIDrawer>
);
